@if (isEditing() && !readonly()) {
  @switch (columnType()) {
    @case ('number') {
      <input
        type="number"
        [value]="value()"
        (blur)="emitCellBlur($event.target)"
        (keydown)="cellKeydown.emit($event)"
        class="min-h-[34px] w-full rounded-md border border-blue-500 bg-white px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    }
    @case ('date') {
      <input
        type="date"
        [value]="value()"
        (blur)="emitCellBlur($event.target)"
        (keydown)="cellKeydown.emit($event)"
        class="min-h-[34px] w-full rounded-md border border-blue-500 bg-white px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    }
    @case ('boolean') {
      <select
        [value]="value()"
        (blur)="emitCellBlur($event.target)"
        (keydown)="cellKeydown.emit($event)"
        class="min-h-[34px] w-full rounded-md border border-blue-500 bg-white px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Selecionar...</option>
        <option value="true">Verdadeiro</option>
        <option value="false">Falso</option>
      </select>
    }
    @default {
      <textarea
        [value]="value()"
        (blur)="emitCellBlur($event.target)"
        (keydown)="cellKeydown.emit($event)"
        [maxLength]="CHAR_LIMIT_PER_CELL"
        class="min-h-[34px] w-full rounded-md border border-blue-500 bg-white px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
      ></textarea>
    }
  }
} @else {
  <div
    (click)="cellClick.emit()"
    (keyup)="cellClick.emit()"
    (focus)="cellClick.emit()"
    [tabindex]="tabindex()"
    class="min-h-[34px] w-full cursor-text whitespace-pre-wrap break-words rounded-md px-2 py-1"
  >
    @if (columnType() === 'boolean' && value() && !skipFormatting()) {
      {{ value() === 'true' ? 'Verdadeiro' : value() === 'false' ? 'Falso' : value() }}
    } @else if (columnType() === 'date' && value() && !skipFormatting()) {
      {{ value() | date: 'dd/MM/yyyy' }}
    } @else {
      {{ value() || '&nbsp;' }}
    }
  </div>
}
